import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_ALL_REQUESTS: '/GetRequestLists',
  GET_ALL_REQUESTCATEGORIES: '/GetRequestLists',
  SEND_ANSWER: '/AnswerToRequest/',
  GET_REQUEST_OPTIONS: '/RequestOptionsYntList/',
  GET_REQUESTCATEGORIES_OPTIONS: '/CitizenCategoryList/',  DELETE_REQUEST_ADDRESS: '/RequestRemove', DELETE_REQ_GROUP: '/CitizenCategoryDelete',
  ADD_REQCATEGORIES:'/CitizenCategoryAdd',
  UPDATE_REQCATEGORIES:'/CitizenCategoryUpdate',
  UPDATE_REQUEST_STATUS: '/RequestDurumDegis',
  GET_REQUEST_LIST_EXCEL: '/GetRequestListsExcel'
};

export const getAllrequest =   async (params) => {
    const {type, count, offset, date, search,basla,bitis,durum} = params;
    const response = await axiosInstance.get(ENDPOINTS.GET_ALL_REQUESTS, { params: {type, count, offset, date, search,basla,bitis,durum} });
    return response.data;
  };
  export const getRequestOptions = async () => {
    const response = await axiosInstance.get(ENDPOINTS.GET_REQUEST_OPTIONS);
    return response.data;
  };
  export const getRequesCategories = async () => {
    const response = await axiosInstance.get(ENDPOINTS.GET_REQUESTCATEGORIES_OPTIONS);
    return response.data;
  };
  export const deleteReqCategories = async (userId) => {
    try {
      const response = await axiosInstance.post(`${ENDPOINTS.DELETE_REQ_GROUP}/${userId}`);
      if (response.data && response.data.status === 200) {
        return 1;
      }
      return 0;
    } catch (error) {
      return 0;
    }
  };
  export const createRequestCategories = async (userData) => {
    try {
      const formData = new FormData();
      formData.append('Adi', userData.adi);
      formData.append('Sira', userData.sira);
      formData.append('AktifMi', true);
      const response = await axiosInstance.post(ENDPOINTS.ADD_REQCATEGORIES, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      if (response.data && response.data.status === 200) {
        return response.data;
      }
      throw new Error(response.data.message || 'Failed to create user');
    } catch (error) {
      console.error('Create user error:', error);
      throw error;
    }
  };

  export const updateReqCategories = async (userId, userData) => {
    try {
      const formData = new FormData();
      formData.append('adi', userData.adi);   
      formData.append('sira', userData.sira);   
      formData.append('AktifMi',true);   
      const response = await axiosInstance.post(`${ENDPOINTS.UPDATE_REQCATEGORIES}/${userId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      if (response.data && response.data.status === 200) {
        return response.data;
      }
      throw new Error(response.data.message || 'Failed to update user');
    } catch (error) {
      console.error('Update user error:', error);
      throw error;
    }
  };
  export const deleteRequest = async (id) => {
    const response = await axiosInstance.post(ENDPOINTS.DELETE_REQUEST_ADDRESS + '/' + id);
    return response.data;
  };

  export const sendAnswer = async (requestId, { text, image }) => {
    const formData = new FormData();
    formData.append("RequestId", requestId); 
    formData.append("Answer", text);        
    if (image) formData.append("image", image); 

    const response = await axiosInstance.post(
      `${ENDPOINTS.SEND_ANSWER}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  };

  export const updateRequestStatus = async ({ id, durum }) => {
    const response = await axiosInstance.put(ENDPOINTS.UPDATE_REQUEST_STATUS, { id, durum });
    return response.data;
  };

  export const sendNotificationCavus = async (requestId) => {
    const response = await axiosInstance.post('/SendNotificationCavus', { RequestId: requestId });
    return response.data;
  };

  export const getRequestListExcel = async (params = {}) => {
    const response = await axiosInstance.get(ENDPOINTS.GET_REQUEST_LIST_EXCEL, {
      params,
      responseType: 'blob',
    });
    return response.data;
  };

